import { IssueProductDetail } from "./issue-product-detail";
import { ReasonCode } from "./reason-code";
import { SystemField } from "./system-field";

export class IssueProduct extends SystemField { 
     ref_code?:string;
     external_ref_code?:string;
     issue_date?:string;
     status?:string;
     post_period?:string;
     reason_code_id?:string;
     total_qty?:number;
     total_cost?:number;
     warehouse_id?:string;
     
     source?:string;

     //relationship
     //parent

     //children
     langs?:any;
     details?:IssueProductDetail[];
     reason_code?:ReasonCode;
}
export class IssueProductTranslate extends SystemField{ 
     lang_code?:string;
     description?:string;
     issue_prod_id?:string;
}